var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { makeImmutable } from "../core";
import { perRestaurant } from "../di";
import { translate, t } from "../I18n";
let TemporarilyUnavailableLabel = class TemporarilyUnavailableLabel {
    constructor() {
        makeImmutable(this);
    }
    shouldAppear(unavailabilityReasons) {
        return (unavailabilityReasons.includes("TemporarilyUnavailable") ||
            unavailabilityReasons.includes("Visibility") ||
            unavailabilityReasons.includes("OutdatedPreorderSettings"));
    }
    label(view, unavailabilityReasons) {
        if (view === "Cart" || !this.shouldAppear(unavailabilityReasons)) {
            return null;
        }
        return {
            message: translate(t.client.labels.temporarily_unavailable.text),
            enabledOnClick: false,
            type: "error",
        };
    }
};
TemporarilyUnavailableLabel = __decorate([
    perRestaurant(),
    __metadata("design:paramtypes", [])
], TemporarilyUnavailableLabel);
export { TemporarilyUnavailableLabel };
